import React from "react";
import { Box, useMediaQuery } from "@chakra-ui/react";

const Wrapper = ({ children, color, opt }) => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");

  return (
    <>
      {color ? (
        <Box
          pt={[0, 0, 70, 20]}
          bg="gradient"
          ml={!isMobile ? "-100px" : "-20px"}
          mr={!isMobile ? "-100px" : "-20px"}
          pl={["20px", "20px", "100px", "110px"]}
          pr={["20px", "20px", "100px", "120px"]}
          pb={opt ? 0 : 50}
        >
          {children}
        </Box>
      ) : (
        <Box
          ml={!isMobile ? "-100px" : "-20px"}
          mr={!isMobile ? "-100px" : "-20px"}
        >
          {children}
        </Box>
      )}
    </>
  );
};

export default Wrapper;
